import { hileiaHttp, platformHttp } from '@/utils/http'

export const apis = {
  getMyself: '/api/enterprise/v0.1/user/getMyself',
  getUserByUid: '/hiapigw/app/user/someoneUserInfo',
  hileiaLogin: '/api/account/signin', // 在本项目中仅用于换token
  hileiaLogout: '/api/user/logout',
  platformLogin: '/api/enterprise/v0.1/account/signin',
  platformLogout: '/api/enterprise/v0.1/account/signout',
  // checkMyPwdStatus: '/api/enterprise/v0.1/user/checkPwdExist',
  checkMyPwdStatus: '/hiapigw/app/user/userInfo',
  // modifyPassword: '/api/enterprise/v0.1/user/updatePasswd',
  modifyPassword: '/hiapigw/app/user/updatePassword',
  imageCode: '/api/chkCode',
  registerCode: '/api/account/checkcodeforregister',
  restpwCode: '/api/account/resetpwdcode',
  restpwCodeKey: '/api/account/resetpwdkey',
  resetpw: '/api/account/resetpwd',
  registerAccount: '/api/account/signup',
}
const Qs = require('qs')
// 获取个人信息
export function getMyself() {
  return platformHttp.post(apis.getMyself)
}

/**
 * 根据uid获取用户信息
 */
export function getUserByUid(uid) {
  return hileiaHttp.get(apis.getUserByUid, {
    params: { uid, _id: 1 }
  }).catch(_ => {
    return null
  })
}

export function loginFromPlatformToken(data) {
  let formData = null
  if (!data.token) {
    formData = Qs.stringify(data)
  }
  return platformHttp.post(apis.hileiaLogin, formData, {
    headers: {
      HiARGlassesToken: data.token ? data.token : '',
      'content-type': 'application/x-www-form-urlencoded'
    },
    isTransformRequestResult: false,
  })
}

export function logoutFromPlatformToken(token) {
  console.trace() // 追踪调用登出触发点
  return hileiaHttp.get(apis.hileiaLogout, {
    headers: {
      HiARGlassesToken: token,
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}

export function platformLogin(data) {
  return platformHttp.post(apis.platformLogin, data)
}

export function platformLogout() {
  return platformHttp.post(apis.platformLogout)
}

export function checkMyPwdStatus() {
  return hileiaHttp.post(apis.checkMyPwdStatus)
}

export function modifyPassword(data) {
  return hileiaHttp.post(apis.modifyPassword, data)
}

export function getRegisterCode(data) {
  return platformHttp.post(apis.registerCode, data, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}

export function getRestpwCode(data) {
  return platformHttp.post(apis.restpwCode, data, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}

export function restpwCodeKey(data) {
  return platformHttp.post(apis.restpwCodeKey, data, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}
export function resetpw(data) {
  return platformHttp.post(apis.resetpw, data, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}

export function registerAccount(data) {
  return platformHttp.post(apis.registerAccount, data, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    params: {
      _id: 1
    },
    isTransformRequestResult: false
  })
}
